module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"verifyEmail":"Подтвердите свой e-mail адрес","emailNotRecieved":"Не пришло письмо","resend":"Отправить еще раз","verificationEmailSent":"Письмо для подтверждения E-mail отправлено"}}')
  delete Component.options._Ctor
}
